import { Component, OnInit, ViewChild, ViewChildren, QueryList, NgZone } from '@angular/core';
import { Router, ActivatedRoute,Params } from '@angular/router';
import { MatDialog, MatSelect } from '@angular/material';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';

import { ListaPreciosVentaGeneral } from '../../models/ListaPreciosVentaGeneral';
import { ListaPreciosVentaDetalle } from '../../models/ListaPreciosVentaDetalle';
import { ListaPreciosVentaTipo } from '../../models/ListaPreciosVentaTipo';
import { ListaPrecios } from '../../models/ListaPrecios';

import { generalService } from '../../services/general.service';

import { DatosGeneralesSAE } from '../../datos-generales-SAE';

import {take} from 'rxjs/operators/take';



@Component({
  selector: 'app-lista-precios-agregar-editar',
  templateUrl: './lista-precios-agregar-editar.component.html',
  styleUrls: ['./lista-precios-agregar-editar.component.scss'],
  providers: [generalService]
})
export class ListaPreciosAgregarEditarComponent implements OnInit {

	/***************************INFINITE SELECT**********************************/
    public viewDataClientes: any[];
	public viewDataProveedor: any[];
    @ViewChild('infiniteSelectUnico') selectElemUnico: MatSelect;
    private itemsShow = 10;
    @ViewChildren('infiniteSelect') selectElem: QueryList<MatSelect>;
    /***************************INFINITE SELECT**********************************/

	// ----------------------------------- DECLARACIÓN DE VARIABLES -----------------------------------
	public userData: any = JSON.parse(sessionStorage.getItem('user'));
	public datosGeneralesSAE: any;
	public idListaPrecios: any = "";

	public listaPreciosGeneral: ListaPreciosVentaGeneral = new ListaPreciosVentaGeneral();
	public listaPreciosDetalles: ListaPreciosVentaDetalle[] = [];

	public listaPreciosTipos: ListaPreciosVentaTipo[] = [];
	public listaClientes: any = [];
	public listaProveedor: any = [];
	public listaTiposDeCliente: any = [];
	public listaFormasDePago: any = [];
	public listaTiposDeVenta: any = [];

	public listaFamiliasOriginal: any = [];
	public listaSubfamiliasOriginal: any = [];
	public listaProductosOriginal: any = [];

	public formListaPrecios: FormGroup;

	public identificadorDetalle: number = 0;

	private idCompraVenta: string;
	public parametroUrl:any;
	public compra = false;
	public venta = false;
	public titulo = ""
	public consultaVentaCompra;

	// ----------------------------------- DECLARACIÓN DE FUNCIONES -----------------------------------

	// ---------------- FUNCIONES DE CARGA ----------------
	constructor(private _generalService: generalService, private route: ActivatedRoute, private router: Router, 
		public dialog: MatDialog, private formBuilder: FormBuilder, private zone: NgZone){ 
		this.datosGeneralesSAE = DatosGeneralesSAE;

		this.crearFormulario();

		this.idCompraVenta = this.route.snapshot.paramMap.get('id');
		this.route.params.forEach((params: Params)=>{
            this.parametroUrl = params['parametro'];
            console.log(this.parametroUrl);
          });

		// Esto es necesario para cambiar de parámetro en la página
		this.route.params.subscribe(routeParams => {
			this.datosGeneralesSAE.showSpinnerLoading = true;
			this.idListaPrecios = routeParams.id;

			if(this.idListaPrecios != "N" && isNaN(this.idListaPrecios)){
				this.datosGeneralesSAE.showSpinnerLoading = false;
				this.router.navigateByUrl('app/lista-precios');
			}
			this.cargarPantalla();
		});
		
	}

	ngOnInit() {
		this.validarVentaCompra()
	}

	cargarPantalla(){
		this.parametroUrl == ':parametro' ? this.consultaVentaCompra = 1 : this.consultaVentaCompra = 0 ;
		if(this.idListaPrecios == "N"){
			this._generalService.requestGet("listaPrecios/consultarInformacionAgregar?idCompania=" + this.userData.COMPANY_ID + "&consultaVentaCompra="+this.consultaVentaCompra).subscribe(
				result => {
					var dataTemp: any = JSON.parse(result);

					this.listaPreciosTipos = dataTemp.Table;
					this.listaClientes = dataTemp.Table1;
					this.listaProveedor = dataTemp.Table8;
					/***************************INFINITE SELECT**********************************/
                    this.viewDataClientes = this.listaClientes.slice(0,10);
					this.viewDataProveedor = this.listaProveedor.slice(0, 10);

                    /***************************INFINITE SELECT**********************************/
					this.listaTiposDeCliente = dataTemp.Table2;
					this.listaFormasDePago = dataTemp.Table3;
					this.listaTiposDeVenta = dataTemp.Table4;

					this.listaFamiliasOriginal = dataTemp.Table5;
					this.listaSubfamiliasOriginal = dataTemp.Table6;
					this.listaProductosOriginal = dataTemp.Table7;

					this.initSelectScroll();

					if(this.listaPreciosTipos.length){
						this.listaPreciosGeneral.SALES_PRICE_LIST_TYPE_ID = this.listaPreciosTipos[0].SALES_PRICE_LIST_TYPE_ID;
						if(this.listaPreciosGeneral.SALES_PRICE_LIST_TYPE_ID == 1){
							this.formListaPrecios.get('Cliente').setValidators([Validators.required]);
							this.formListaPrecios.get('Cliente').updateValueAndValidity();
						}
	
						if(this.listaPreciosGeneral.SALES_PRICE_LIST_TYPE_ID == 2){
							this.formListaPrecios.get('TipoCliente').setValidators([Validators.required]);
							this.formListaPrecios.get('TipoCliente').updateValueAndValidity();
						}
	
						if(this.listaPreciosGeneral.SALES_PRICE_LIST_TYPE_ID == 3){
							this.formListaPrecios.get('FormaPago').setValidators([Validators.required]);
							this.formListaPrecios.get('FormaPago').updateValueAndValidity();
						}
	
						if(this.listaPreciosGeneral.SALES_PRICE_LIST_TYPE_ID == 4){
							this.formListaPrecios.get('TipoVenta').setValidators([Validators.required]);
							this.formListaPrecios.get('TipoVenta').updateValueAndValidity();
						}
						if(this.listaPreciosGeneral.SALES_PRICE_LIST_TYPE_ID == 5){
							this.formListaPrecios.get('Proveedor').setValidators([Validators.required]);
							this.formListaPrecios.get('Proveedor').updateValueAndValidity();
						}
					}

					this.agregarDetalle();

					this.datosGeneralesSAE.showSpinnerLoading = false;

				},
				error => {
				  var errorMsj = <any>error;
				  console.log(errorMsj);
				}
			);
		}
		else{
			this._generalService.requestGet("listaPrecios/consultarInformacionEditar?idCompania=" + this.userData.COMPANY_ID + "&idListaPrecios=" + this.idListaPrecios+ "&consultaVentaCompra="+this.consultaVentaCompra).subscribe(
				result => {
					var dataTemp: any = JSON.parse(result);

					this.listaPreciosTipos = dataTemp.Table2;
					this.listaClientes = dataTemp.Table3;
					this.listaProveedor = dataTemp.Table10;
					/***************************INFINITE SELECT**********************************/
                    this.viewDataClientes = this.listaClientes.slice(0,10);
					 this.viewDataProveedor = this.listaProveedor.slice(0, 10);

                    /***************************INFINITE SELECT**********************************/
					
					this.listaTiposDeCliente = dataTemp.Table4;
					this.listaFormasDePago = dataTemp.Table5;
					this.listaTiposDeVenta = dataTemp.Table6;

					this.listaFamiliasOriginal = dataTemp.Table7;
					this.listaSubfamiliasOriginal = dataTemp.Table8;
					this.listaProductosOriginal = dataTemp.Table9;

					this.listaPreciosGeneral = dataTemp.Table[0];
					this.listaPreciosDetalles = dataTemp.Table1;

					this.initSelectScroll();

					// Verifica el tipo de lista de precios para poner la validación al listado correspondiente
					if(this.listaPreciosGeneral.SALES_PRICE_LIST_TYPE_ID == 1){
						this.formListaPrecios.get('Cliente').setValidators([Validators.required]);
						this.formListaPrecios.get('Cliente').updateValueAndValidity();
					}

					if(this.listaPreciosGeneral.SALES_PRICE_LIST_TYPE_ID == 2){
						this.formListaPrecios.get('TipoCliente').setValidators([Validators.required]);
						this.formListaPrecios.get('TipoCliente').updateValueAndValidity();
					}

					if(this.listaPreciosGeneral.SALES_PRICE_LIST_TYPE_ID == 3){
						this.formListaPrecios.get('FormaPago').setValidators([Validators.required]);
						this.formListaPrecios.get('FormaPago').updateValueAndValidity();
					}

					if(this.listaPreciosGeneral.SALES_PRICE_LIST_TYPE_ID == 4){
						this.formListaPrecios.get('TipoVenta').setValidators([Validators.required]);
						this.formListaPrecios.get('TipoVenta').updateValueAndValidity();
					}
					if(this.listaPreciosGeneral.SALES_PRICE_LIST_TYPE_ID == 5){
						this.formListaPrecios.get('Proveedor').setValidators([Validators.required]);
						this.formListaPrecios.get('Proveedor').updateValueAndValidity();
					}

					// Crear los form control de los detalles
					for(var i = 0; i < this.listaPreciosDetalles.length; i++){
						this.identificadorDetalle++;
						this.listaPreciosDetalles[i].IDENTIFICADOR_ESCALA = this.identificadorDetalle;

						this.listaPreciosDetalles[i].LISTA_FAMILIAS = this.listaFamiliasOriginal.map(x => Object.assign({}, x));
						this.listaPreciosDetalles[i].LISTA_FAMILIAS.unshift({
							ITEM_FAMILY_ID: 0,
							NAME: "TODAS"
						});
						if(this.listaPreciosDetalles[i].ITEM_FAMILY_ID == null){
							this.listaPreciosDetalles[i].ITEM_FAMILY_ID = 0;
						}

						this.listaPreciosDetalles[i].LISTA_SUBFAMILIAS = this.listaSubfamiliasOriginal.map(x => Object.assign({}, x));
						this.listaPreciosDetalles[i].LISTA_SUBFAMILIAS.unshift({
							ITEM_SUBFAMILY_ID: 0,
							NAME: "TODAS",
							ITEM_FAMILY_ID: 0
						});
						if(this.listaPreciosDetalles[i].ITEM_SUBFAMILY_ID == null){
							this.listaPreciosDetalles[i].ITEM_SUBFAMILY_ID = 0;
						}

						this.listaPreciosDetalles[i].LISTA_PRODUCTOS = this.listaProductosOriginal.map(x => Object.assign({}, x));

						/***************************INFINITE SELECT**********************************/
					    const index = this.listaPreciosDetalles[i].LISTA_PRODUCTOS.findIndex(x => x.ITEM_ID == this.listaPreciosDetalles[i].ITEM_ID);
					    var a = this.listaPreciosDetalles[i].LISTA_PRODUCTOS.splice(index,1);
					    this.listaPreciosDetalles[i].LISTA_PRODUCTOS.unshift(a[0]);
					    /***************************INFINITE SELECT**********************************/

						this.listaPreciosDetalles[i].LISTA_PRODUCTOS.unshift({
							ITEM_ID: 0,
							NAME: "TODAS",
							ITEM_SUBFAMILY_ID: 0
						});
						this.listaPreciosDetalles[i].LISTA_PRODUCTOS_FILTRADA = this.listaPreciosDetalles[i].LISTA_PRODUCTOS.map(x => Object.assign({}, x)).slice(0, 10);
						if(this.listaPreciosDetalles[i].ITEM_ID == null){
							this.listaPreciosDetalles[i].ITEM_ID = 0;
						}

						this.listaPreciosDetalles[i].itemsShow = 10;
						this.initSelectScrollMulti();

						this.agregarFormControlsDetalle(this.identificadorDetalle, 1);
					}
					
					this.moverSeleccion();
					this.datosGeneralesSAE.showSpinnerLoading = false;

				},
				error => {
				  var errorMsj = <any>error;
				  console.log(errorMsj);
				}
			);
		}
	}

	initSelectScroll() {
		/***************************INFINITE SELECT**********************************/
		this.zone.onMicrotaskEmpty.asObservable().pipe(
	    	take(1)
	    )
	    .subscribe(() => {
	    	this.selectElemUnico.onOpen.subscribe(() => this.registerPanelScrollEventUnico());
	    });
		/***************************INFINITE SELECT**********************************/
	}

	initSelectScrollMulti() {
		/***************************INFINITE SELECT**********************************/
		this.zone.onMicrotaskEmpty.asObservable().pipe(
			take(1)
		)
		.subscribe(() => {
			this.selectElem.toArray().forEach(el => {el.onOpen.subscribe(() => this.registerPanelScrollEvent(el));});
		});
		/***************************INFINITE SELECT**********************************/
	}


	// ------------- FUNCIONES DE FORMULARIO --------------
	crearFormulario() {
		this.formListaPrecios = this.formBuilder.group({
			Nombre: this.formBuilder.control("", [Validators.required]),
			Tipo: this.formBuilder.control("", [Validators.required]),
			Cliente: this.formBuilder.control(""),
			Proveedor: this.formBuilder.control(""),
			TipoCliente: this.formBuilder.control(""),
			FormaPago: this.formBuilder.control(""),
			TipoVenta: this.formBuilder.control(""),
			FechaInicioVigencia: this.formBuilder.control("", [Validators.required]),
			FechaFinVigencia: this.formBuilder.control("")
		});
	}

	agregarFormControlsDetalle(indice: number, opcion: number){
		this.formListaPrecios.addControl('Familia' + indice, this.formBuilder.control("", [Validators.required]));
		this.formListaPrecios.addControl('Subfamilia' + indice, this.formBuilder.control("", [Validators.required]));
		this.formListaPrecios.addControl('Producto' + indice, this.formBuilder.control("", [Validators.required]));
		this.formListaPrecios.addControl('RangoInicial' + indice, this.formBuilder.control("", [Validators.required]));
		this.formListaPrecios.addControl('RangoFinal' + indice, this.formBuilder.control({value: '', disabled: opcion == 0 ? true : false}, [Validators.required]));
		this.formListaPrecios.addControl('Factor' + indice, this.formBuilder.control("", [Validators.required]));
	}

	eliminarFormControlsDetalle(indice: number){
		this.formListaPrecios.removeControl('Familia' + indice);
		this.formListaPrecios.removeControl('Subfamilia' + indice);
		this.formListaPrecios.removeControl('Producto' + indice);
		this.formListaPrecios.removeControl('RangoInicial' + indice);
		this.formListaPrecios.removeControl('RangoFinal' + indice);
		this.formListaPrecios.removeControl('Factor' + indice);
	}


	// ------ FUNCIONES DE LISTA DE PRECIOS GENERAL -------
	cambiarTipoListaPrecios(opcion: number){
		this.listaPreciosGeneral.DESTINATION_ID = null;

		this.formListaPrecios.get('Cliente').clearValidators();
		this.formListaPrecios.get('Cliente').updateValueAndValidity();

		this.formListaPrecios.get('TipoCliente').clearValidators();
		this.formListaPrecios.get('TipoCliente').updateValueAndValidity();

		this.formListaPrecios.get('FormaPago').clearValidators();
		this.formListaPrecios.get('FormaPago').updateValueAndValidity();

		this.formListaPrecios.get('TipoVenta').clearValidators();
		this.formListaPrecios.get('TipoVenta').updateValueAndValidity();

		this.formListaPrecios.get('Proveedor').clearValidators();
		this.formListaPrecios.get('Proveedor').updateValueAndValidity();

		if(this.listaPreciosGeneral.SALES_PRICE_LIST_TYPE_ID == 1){
			this.formListaPrecios.get('Cliente').setValidators([Validators.required]);
			this.formListaPrecios.get('Cliente').updateValueAndValidity();
		}

		if(this.listaPreciosGeneral.SALES_PRICE_LIST_TYPE_ID == 2){
			this.formListaPrecios.get('TipoCliente').setValidators([Validators.required]);
			this.formListaPrecios.get('TipoCliente').updateValueAndValidity();
		}

		if(this.listaPreciosGeneral.SALES_PRICE_LIST_TYPE_ID == 3){
			this.formListaPrecios.get('FormaPago').setValidators([Validators.required]);
			this.formListaPrecios.get('FormaPago').updateValueAndValidity();
		}

		if(this.listaPreciosGeneral.SALES_PRICE_LIST_TYPE_ID == 4){
			this.formListaPrecios.get('TipoVenta').setValidators([Validators.required]);
			this.formListaPrecios.get('TipoVenta').updateValueAndValidity();
		}
		if(this.listaPreciosGeneral.SALES_PRICE_LIST_TYPE_ID == 5){
			this.formListaPrecios.get('Proveedor').setValidators([Validators.required]);
			this.formListaPrecios.get('Proveedor').updateValueAndValidity();
		}
	}


	// ------ FUNCIONES DE LISTA DE PRECIOS DETALLES ------
	agregarDetalle(){
		this.identificadorDetalle++;

		var detalle: ListaPreciosVentaDetalle = new ListaPreciosVentaDetalle();
		detalle.LISTA_FAMILIAS = this.listaFamiliasOriginal.map(x => Object.assign({}, x));
		detalle.LISTA_FAMILIAS.unshift({
			ITEM_FAMILY_ID: 0,
			NAME: "TODAS"
		});

		detalle.LISTA_SUBFAMILIAS = this.listaSubfamiliasOriginal.map(x => Object.assign({}, x));
		detalle.LISTA_SUBFAMILIAS.unshift({
			ITEM_SUBFAMILY_ID: 0,
			NAME: "TODAS",
			ITEM_FAMILY_ID: 0
		});

		detalle.LISTA_PRODUCTOS = this.listaProductosOriginal.map(x => Object.assign({}, x));
		detalle.LISTA_PRODUCTOS.unshift({
			ITEM_ID: 0,
			NAME: "TODAS",
			ITEM_SUBFAMILY_ID: 0
		});
		detalle.LISTA_PRODUCTOS_FILTRADA = detalle.LISTA_PRODUCTOS.map(x => Object.assign({}, x)).slice(0, 10);
		detalle.IDENTIFICADOR_ESCALA = this.identificadorDetalle;
		detalle.itemsShow = 10;

		/***************************INFINITE SELECT**********************************/
        detalle.arrayFilteredProd = undefined;
        detalle.filteredItemsShow = 10;
        detalle.isFilteredProd = false;
        /***************************INFINITE SELECT**********************************/

		this.listaPreciosDetalles.push(detalle);
		this.agregarFormControlsDetalle(this.identificadorDetalle, 0);
		this.initSelectScrollMulti();
	}

	eliminarDetalle(escala: ListaPreciosVentaDetalle, indice: number){
		this.eliminarFormControlsDetalle(escala.IDENTIFICADOR_ESCALA);
		this.listaPreciosDetalles.splice(indice, 1);
		/***************************INFINITE SELECT**********************************/
        this.selectElem.toArray().splice(indice, 1);
        /***************************INFINITE SELECT**********************************/
	}

	cambiarFamilia(escala: ListaPreciosVentaDetalle){
		// Se limpian las subfamilias
		escala.LISTA_SUBFAMILIAS = [];
		escala.ITEM_SUBFAMILY_ID = null;

		escala.LISTA_SUBFAMILIAS.push({
			ITEM_SUBFAMILY_ID: 0,
			NAME: "TODAS",
			ITEM_FAMILY_ID: 0
		});
		for(var i = 0; i < this.listaSubfamiliasOriginal.length; i++){
			if(escala.ITEM_FAMILY_ID == 0){
				escala.LISTA_SUBFAMILIAS.push(Object.assign({}, this.listaSubfamiliasOriginal[i]));
			}
			else{
				if(this.listaSubfamiliasOriginal[i].ITEM_FAMILY_ID == escala.ITEM_FAMILY_ID){
					escala.LISTA_SUBFAMILIAS.push(Object.assign({}, this.listaSubfamiliasOriginal[i]));
				}
			}
		}

		// Se limpian los productos 
		escala.LISTA_PRODUCTOS = [];
		escala.LISTA_PRODUCTOS_FILTRADA = [];
		escala.ITEM_ID = null;

		// Se limpian los rangos
		escala.INITIAL_RANGE = null;
		escala.FINAL_RANGE = null;
		this.formListaPrecios.get('RangoFinal' + escala.IDENTIFICADOR_ESCALA).disable();
	}

	cambiarSubfamilia(escala: ListaPreciosVentaDetalle){
		// Se limpian los productos
		escala.LISTA_PRODUCTOS = [];
		escala.LISTA_PRODUCTOS_FILTRADA = [];
		escala.ITEM_ID = null;

		escala.LISTA_PRODUCTOS.push({
			ITEM_ID: 0,
			NAME: "TODOS",
			ITEM_SUBFAMILY_ID: 0
		});
		for(var i = 0; i < this.listaProductosOriginal.length; i++){
			if(escala.ITEM_SUBFAMILY_ID == 0){
				escala.LISTA_PRODUCTOS.push(Object.assign({}, this.listaProductosOriginal[i]));
			}
			else{
				if(this.listaProductosOriginal[i].ITEM_SUBFAMILY_ID == escala.ITEM_SUBFAMILY_ID){
					escala.LISTA_PRODUCTOS.push(Object.assign({}, this.listaProductosOriginal[i]));
				}
			}
		}
		escala.LISTA_PRODUCTOS_FILTRADA = escala.LISTA_PRODUCTOS;

		// Se limpian los rangos
		escala.INITIAL_RANGE = null;
		escala.FINAL_RANGE = null;
		this.formListaPrecios.get('RangoFinal' + escala.IDENTIFICADOR_ESCALA).disable();
	}

	cambiarProducto(escala: ListaPreciosVentaDetalle){
		// Se limpian los rangos
		escala.INITIAL_RANGE = null;
		escala.FINAL_RANGE = null;
		this.formListaPrecios.get('RangoFinal' + escala.IDENTIFICADOR_ESCALA).disable();
	}

	filtrarProducos(escala: ListaPreciosVentaDetalle){
		let arr: any[];
	    if (escala.LISTA_PRODUCTOS_FILTER) {
			escala.arrayFilteredProd = escala.LISTA_PRODUCTOS.filter((obj) => {
				return obj.NAME.toLowerCase().indexOf(escala.LISTA_PRODUCTOS_FILTER.toLowerCase()) > -1;
			});

			arr = escala.arrayFilteredProd.slice(0, escala.filteredItemsShow);
            escala.isFilteredProd = true;
	    } 
	    else {
	    	//arr = escala.LISTA_PRODUCTOS;
	    	/***************************INFINITE SELECT**********************************/
	    	escala.isFilteredProd = false;
            escala.filteredItemsShow = 10;
            escala.arrayFilteredProd = undefined;
            arr = escala.LISTA_PRODUCTOS.slice(0, escala.itemsShow);
            /***************************INFINITE SELECT**********************************/
	    }
	    escala.LISTA_PRODUCTOS_FILTRADA = arr;
	}

	cambiarRangoInicial(escala: ListaPreciosVentaDetalle, opcion: string){
		// Se quita el valor del final del rango seleccionado y se deshabilita
		escala.FINAL_RANGE = null;
		this.formListaPrecios.get('RangoFinal' + escala.IDENTIFICADOR_ESCALA).enable();

		var rangoInicial = Number(escala.INITIAL_RANGE);
		if(opcion == "blur"){
			// 1.- Se verifica que el inicio del rango seleccionado sea un valor posible; mayor a 0
			if(rangoInicial <= 0){
				rangoInicial = 1;
			}

			// 2.- Se verifica que el inicio del rango seleccionado tenga un valor correcto; que no se encuentre dentro de los rangos de las demás 
			// escalas que compartan la misma información de producto y que haya un espacio entre el y el rango que iría posterior a el de otra escala 
			// con la misma información de tal manera que se pueda poner un final del rango seleccionado
			var rangoFinalMayor = 0;
			var rangoInicialCorrecto = true;
			for(var i = 0; i < this.listaPreciosDetalles.length; i++){
				// Se recorren todas las demás escalas para encontrar las que comparten la misma información de producto
				if(this.listaPreciosDetalles[i].IDENTIFICADOR_ESCALA != escala.IDENTIFICADOR_ESCALA){
					if(this.listaPreciosDetalles[i].ITEM_FAMILY_ID == escala.ITEM_FAMILY_ID && this.listaPreciosDetalles[i].ITEM_SUBFAMILY_ID == escala.ITEM_SUBFAMILY_ID && this.listaPreciosDetalles[i].ITEM_ID == escala.ITEM_ID){
						// Se verifica que la escala que comparte la misma información de producto tenga un rango completo (inicio y fin)
						if(this.listaPreciosDetalles[i].INITIAL_RANGE && this.listaPreciosDetalles[i].FINAL_RANGE){
							// Se verifica que el inicio del rango seleccionado este dentro del rango de otra escala o si no está que no tenga suficiente espacio
							// entre el y el rango que iría posterior a el de otra escala para poner un final del rango seleccionado ya que esto indica que 
							// el inicio del rango seleccionado tiene un valor incorrecto
							if(rangoInicial >= (Number(this.listaPreciosDetalles[i].INITIAL_RANGE) - 1) && (rangoInicial <= Number(this.listaPreciosDetalles[i].FINAL_RANGE))){
								rangoInicialCorrecto = false;
							}

							// Además de verificar si el inicio de rango es correcto, se obtiene cual es más grande final de los rangos de todas las escalas que 
							// comparten la misma información de producto para que si está mal el inicio del rango seleccionado se ponga por default un 
							// rango en base a esta obtención
							if(rangoFinalMayor < Number(this.listaPreciosDetalles[i].FINAL_RANGE)){
								rangoFinalMayor = Number(this.listaPreciosDetalles[i].FINAL_RANGE);
							}
						}
						else{
							// Si se quedó incompleto el rango de otra escala que comparte la misma información no se toma en cuenta pero también
							// se limpia ya que esos valores estarían incorrectos al no estar actualizados y validados en base al nuevo rango seleccionado
							this.listaPreciosDetalles[i].INITIAL_RANGE = null;
							this.listaPreciosDetalles[i].FINAL_RANGE = null;
						}
					}	
				}
			}

			// 3.- Si el inicio del rango seleccionado no es correcto, se pone por default un rango correcto el cual sería el más grande final de los rangos de 
			// todas las escalas que comparten la misma información de producto + 1
			if(!rangoInicialCorrecto){
				rangoInicial = rangoFinalMayor + 1;
			}

			escala.INITIAL_RANGE = rangoInicial;
		}
	}

	cambiarRangoFinal(escala: ListaPreciosVentaDetalle, opcion: string){
		var rangoInicial = Number(escala.INITIAL_RANGE);
		var rangoFinal = Number(escala.FINAL_RANGE);

		if(opcion == "blur"){
			// 1.- Se verifica que el final del rango seleccionado sea un valor posible; mayor al inicio del rango seleccionado
			if(rangoFinal <= rangoInicial){
				// Si no es mayor, el final del rango seleccionado se igual al inicio del rango seleccionado + 1, ya que ese valor se valido que 
				// fuera posible poner cuando se válido el inicio del rango seleccionado y no se tiene que hacer nada más
				rangoFinal = rangoInicial + 1;
			}
			else{
				// 2.- Si el final del rango seleccionado es mayor al inicio del rango seleccionado, se tiene que verificar que el final del rango seleccionado
				// sea correcto al no tener ningún rango de otras escalas que comparten la misma información de producto entre el y el inicio del rango seleccionado
				var rangoFinalCorrecto = true;
				var rangoInicialPosterior = -1;
				// Se recorren todas las demás escalas para encontrar las que comparten la misma información de producto
				for(var i = 0; i < this.listaPreciosDetalles.length; i++){
					if(this.listaPreciosDetalles[i].IDENTIFICADOR_ESCALA != escala.IDENTIFICADOR_ESCALA){
						if(this.listaPreciosDetalles[i].ITEM_FAMILY_ID == escala.ITEM_FAMILY_ID && this.listaPreciosDetalles[i].ITEM_SUBFAMILY_ID == escala.ITEM_SUBFAMILY_ID && this.listaPreciosDetalles[i].ITEM_ID == escala.ITEM_ID){
							// Se verifica que la escala que comparte la misma información de producto tenga un rango completo (inicio y fin)
							if(this.listaPreciosDetalles[i].INITIAL_RANGE && this.listaPreciosDetalles[i].FINAL_RANGE){
								// Se encuentran los rangos de las escalas que empiezan después del inicio del rango seleccionado
								if(rangoInicial < Number(this.listaPreciosDetalles[i].INITIAL_RANGE)){
									// Se verifica que el final del rango seleccionado sea mayor al rango inicial de otra escala, ya que esto indicaría que es un valor incorrecto
									// al haber entre el inicio y final del rango seleccionado un rango de otra escala
									if(rangoFinal >= Number(this.listaPreciosDetalles[i].INITIAL_RANGE)){
										rangoFinalCorrecto = false;
									}

									// Además de verificar si el final del rango seleccionado es correcto o no, se obtiene el inicio del rango de la escala que va posterior al 
									// rango seleccionado para que si es incorrecto el final del rango seleccionado se ponga por default un final de rango correcto en base a 
									// esta obtención
									if(rangoInicialPosterior == -1){
										rangoInicialPosterior = Number(this.listaPreciosDetalles[i].INITIAL_RANGE);
									}
									else{
										if(rangoInicialPosterior > Number(this.listaPreciosDetalles[i].INITIAL_RANGE)){
											rangoInicialPosterior = Number(this.listaPreciosDetalles[i].INITIAL_RANGE);
										}
									}
								}
							}
							else{
								// Si se quedó incompleto el rango de otra escala que comparte la misma información no se toma en cuenta pero también
								// se limpia ya que esos valores estarían incorrectos al no estar actualizados y validados en base al nuevo rango seleccionado
								this.listaPreciosDetalles[i].INITIAL_RANGE = null;
								this.listaPreciosDetalles[i].FINAL_RANGE = null;
							}
						}
					}
				}

				// 3.- Si final del rango seleccionado no es correcto, se iguala al inicio del rango de la escala que va posterior al rango seleccionado - 1
				if(!rangoFinalCorrecto){
					rangoFinal = rangoInicialPosterior - 1;
				}
			}

			escala.FINAL_RANGE = rangoFinal;
		}
	}

	cambiarFactor(escala: ListaPreciosVentaDetalle){
		var factor = Number(escala.PRICE_FACTOR);

		if(factor <= 0.01){
			escala.PRICE_FACTOR = 0.01;
		}

		if(factor > 999.99){
			escala.PRICE_FACTOR = 999.99;
		}
	}


	// -------------- FUNCIONES DE ACCIONES ---------------
	regresar(){
		this.parametroUrl == ':parametro' ? this.router.navigateByUrl('app/lista-precios-Compra/:parametro') :
											this.router.navigateByUrl('app/lista-precios');
	}

	guardar(){
		if(this.formListaPrecios.valid){
			this.datosGeneralesSAE.showSpinnerLoading = true;

			if(this.idListaPrecios == "N"){
				var params: ListaPrecios = new ListaPrecios();
				params.idCompania = this.userData.COMPANY_ID;
				params.realizoAlta = this.userData.USER_ID;
				params.listaPreciosGeneral = this.listaPreciosGeneral;
				params.listaPreciosDetalles = this.listaPreciosDetalles;

				this.parametroUrl == ':parametro' ? params.ventaCompra = 1 : params.ventaCompra = 0 ;

				this._generalService.requestPostParams(params, "listaPrecios/agregarListaPrecios/").subscribe(
			        result => {
			        	this.datosGeneralesSAE.showSpinnerLoading = false;

			        	if(result > 1){
				        	this._generalService.toastCall("Lista de Precios guardada existosamente!");
				        	//this.router.navigateByUrl('app/lista-precios/' + result);
				        	//this.router.navigate(['/app/lista-precios/' + result]);

							 this.parametroUrl == ':parametro' ? this.router.navigateByUrl('app/lista-precios-Compra/:parametro') :
											this.router.navigateByUrl('app/lista-precios');
				        }
				        else{
				        	this._generalService.toastCall("Ya existe una Lista de Precios con ese nombre");
				        }
			        },
			        error => {
			          var errorMsj = <any>error;
			          console.log(errorMsj);
			        }
		        );
			}
			else{
				var params: ListaPrecios = new ListaPrecios();
				params.idCompania = this.userData.COMPANY_ID;
				params.realizoCambio = this.userData.USER_ID;
				params.listaPreciosGeneral = this.listaPreciosGeneral;
				params.listaPreciosDetalles = this.listaPreciosDetalles;

				this._generalService.requestPostParams(params, "listaPrecios/editarListaPrecios/").subscribe(
			        result => {
			        	this.datosGeneralesSAE.showSpinnerLoading = false;

			        	if(result > 1){
				        	this._generalService.toastCall("Lista de Precios actualizada existosamente!");
				        	//this.router.navigateByUrl('app/lista-precios');
							this.parametroUrl == ':parametro' ? this.router.navigateByUrl('app/lista-precios-Compra/:parametro') :
											this.router.navigateByUrl('app/lista-precios');
				        }
				        else{
				        	this._generalService.toastCall("Ya existe una Lista de Precios con ese nombre");
				        }
			        },
			        error => {
			          var errorMsj = <any>error;
			          console.log(errorMsj);
			        }
		        );
			}
		}
	}

	// -------------- FUNCIONES SECUNDARIAS ---------------
	hasDecimalPlace(value: any, decimales: any) {
		// Verifica que solo cuente con las decimales que se establecio en el input
		const ed = value.split(".");
		if(ed.length > 1){
			return ed[1].length > 2;
		}
		else{
			return false;
		}
	}

	inputNumerosConDecimales(e: any, valor: any, decimales: number): boolean {

		// Verifica que la tecla ingresada fuera copiar, pegar, eliminar, numeros o puntos decimales
		if ([8, 9, 13, 27, 46, 110, 190].indexOf(e.keyCode) !== -1 || (e.keyCode === 65 && e.ctrlKey === true) || 
			(e.keyCode >= 35 && e.keyCode <= 39) || (e.keyCode >= 48 && e.keyCode <= 57) || 
			(e.keyCode === 67 && e.ctrlKey === true) || (e.keyCode === 86 && e.ctrlKey === true) || 
			(e.keyCode === 88 && e.ctrlKey === true)) {

			const character = String.fromCharCode(e.keyCode);
			valor = (valor) ? valor : '';
			const newValue: any = valor + character;
			// Verifica que no tenga más de un punto y que solo cuente con las decimales que se establecio en el input
			if (isNaN(newValue) || this.hasDecimalPlace(newValue, decimales)) {
				e.preventDefault();
				return false;
			}
			else{
				return;
			}
		}
		else{
			e.preventDefault();
			return false;
		}
		
	}

	inputNumerosEnteros(event: any, valor: any) {
		const e = event as KeyboardEvent;

		// Verifica que la tecla ingresada fuera copiar, pegar, eliminar o numeros 
		if ([8, 9, 27, 13, 110, 190].indexOf(e.keyCode) !== -1 || (e.keyCode === 65 && e.ctrlKey === true) || 
			(e.keyCode >= 35 && e.keyCode <= 39) || (e.keyCode >= 48 && e.keyCode <= 57) || 
			(e.keyCode === 67 && e.ctrlKey === true) || (e.keyCode === 86 && e.ctrlKey === true) || 
			(e.keyCode === 88 && e.ctrlKey === true)) {
			return;
		}
		else{
			e.preventDefault();
			return false;
		}
	}

	onPaste(e: any) {

		e.preventDefault();
	}


	/***************************INFINITE SELECT**********************************/
    registerPanelScrollEvent(el) {
        const panel = el.panel.nativeElement;
        panel.addEventListener('scroll', event => this.loadAllOnScroll(event, el.id));
    }

    loadAllOnScroll(event, id: string) {
        const idProd = parseInt(id.replace('Producto', ''));
        if (event.target.scrollTop === (event.target.scrollHeight - event.target.offsetHeight)) {
        	if(this.listaPreciosDetalles[idProd].isFilteredProd) {
        		if (this.listaPreciosDetalles[idProd].filteredItemsShow < this.listaPreciosDetalles[idProd].arrayFilteredProd.length) {
                    this.listaPreciosDetalles[idProd].filteredItemsShow += 10;
                    this.listaPreciosDetalles[idProd].LISTA_PRODUCTOS_FILTRADA = this.listaPreciosDetalles[idProd].arrayFilteredProd.slice(0, this.listaPreciosDetalles[idProd].filteredItemsShow);
                    //this.ref.detectChanges();
                }
        	} else {
	        	if(this.listaPreciosDetalles[idProd].itemsShow < this.listaPreciosDetalles[idProd].LISTA_PRODUCTOS.length) {
		            this.listaPreciosDetalles[idProd].itemsShow += 10;
		            this.listaPreciosDetalles[idProd].LISTA_PRODUCTOS_FILTRADA = this.listaPreciosDetalles[idProd].LISTA_PRODUCTOS.slice(0, this.listaPreciosDetalles[idProd].itemsShow);
		            // this.ref.detectChanges();
	        	}
        	}
        }
    }

    registerPanelScrollEventUnico() {
        const panel = this.selectElemUnico.panel.nativeElement;
        panel.addEventListener('scroll', event => this.loadAllOnScrollUnico(event));
    }

    loadAllOnScrollUnico(event) {
        if (event.target.scrollTop === (event.target.scrollHeight - event.target.offsetHeight) && this.itemsShow < this.listaClientes.length) {
          this.itemsShow += 10;
          this.viewDataClientes = this.listaClientes.slice(0, this.itemsShow);
          // this.ref.detectChanges();
        }
    }
    /***************************INFINITE SELECT**********************************/

    moverSeleccion() {
	    /***************************INFINITE SELECT**********************************/
	    const index = this.listaClientes.findIndex(x => x.itemSATcodeId == this.listaPreciosGeneral.DESTINATION_ID);
	    var a = this.listaClientes.splice(index,1);
	    this.listaClientes.unshift(a[0]);
	    
	    this.viewDataClientes = this.listaClientes.slice(0, 10);
	    /***************************INFINITE SELECT**********************************/
	}
	validarVentaCompra(){
        if (this.idCompraVenta === 'N'){
            if( this.parametroUrl == ':parametro')
            {
				this.titulo = "Compra"
                this.compra = true;
				this.venta = false;
            }
            else
            {
                this.compra = false;
				this.venta = true;
				this.titulo = "Venta"
            }
        }
            
    }

}



// WEBPACK FOOTER //
// ./src/app/lista-precios/lista-precios-agregar-editar/lista-precios-agregar-editar.component.ts